import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { HeaderComponent } from '../header'
import { debounce } from 'src/scripts/utils/debounce'
import { isMobile } from 'src/scripts/utils/check-media'

const SCROLLTRACK_ATTRIBUTE = 'data-with-scrolltrack'
const HEADER_SELECTOR = 'header-component'
const SMALL_CLASS = 'product__info-wrapper--small'
const WIDE_CLASS = 'product__info-wrapper--wide'
const WIDE_PLUS_CLASS = 'product__info-wrapper--wide-plus'

export class ProductInfo extends BaseComponent {
  headerHeight: number
  defaultTopSpace: number
  infoHeight: number
  isToSetMoreHeight: boolean
  resizeObserver: ResizeObserver

  mountComponent() {
    const isWithScrollTrack = this.hasAttribute(SCROLLTRACK_ATTRIBUTE)

    if (isWithScrollTrack) {
      customElements.whenDefined('header-component').then(() => {
        this.addListener(window, 'scroll', this.handleScroll)
      })

      if (this.isEditor) {
        this.editor.on('SECTION_LOAD', this.handleSectionLoad)
      }
    }

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(this)
  }

  setDimentions = () => {
    this.defaultTopSpace = 16
    this.infoHeight = this.getBoundingClientRect().height

    const header: HeaderComponent = $el(HEADER_SELECTOR)
    const headerSection = header.section

    this.headerHeight = headerSection.offsetHeight

    this.isToSetMoreHeight = header.getAttribute('is-sticky') === 'static'
  }

  handleScroll = () => {
    const topSpace = this.isToSetMoreHeight
      ? this.defaultTopSpace + this.headerHeight
      : this.defaultTopSpace

    const viewportHeight = window.innerHeight - topSpace

    if (window.scrollY > 0 && this.infoHeight > viewportHeight) {
      this.style.top = `${viewportHeight - this.infoHeight}px`
    } else {
      this.style.top = `${topSpace}px`
    }
  }

  handleSectionLoad = () => {
    this.setDimentions()
  }

  handleResize = debounce(() => {
    if (!isMobile()) {
      this.toggleWidthClasses()
      this.setDimentions()
    }
  }, 50)

  toggleWidthClasses = () => {
    const infoWidth = this.getBoundingClientRect().width

    this.classList.toggle(SMALL_CLASS, infoWidth < 380)
    this.classList.toggle(WIDE_CLASS, infoWidth > 480)
    this.classList.toggle(WIDE_PLUS_CLASS, infoWidth > 740)
  }
}
